import useTracking from '@hooks/useTracking'
import { CookWidget } from '@widgets/types'
import Playlist from '@widgets/Video/playlist/Playlist'
import { FunctionComponent, useEffect, useState } from 'react'
import { useQueryClient } from 'react-query'
import { videoPlaylistShowHandler } from '../hooks/tracking/eventMapper'
import { PlaylistAPIProps } from './types'
import { cleanUpPlaylistData } from './utils'

const PlaylistVideosWidget: FunctionComponent<PlaylistAPIProps> = (props) => {
  const { title, isPlayingId, items } = props
  const queryClient = useQueryClient()

  const trackPlaylistShow = useTracking(videoPlaylistShowHandler)

  useState(() => {
    const cleanedUpRestOfProps = cleanUpPlaylistData({
      title,
      isPlayingId,
      items,
    })

    if (cleanedUpRestOfProps) {
      queryClient.setQueryData('playlist-videos', cleanedUpRestOfProps)
    }
  })

  /**
   * Tracking the impression at a widget level since
   * we are moving the item around on Desktop
   */
  useEffect(() => {
    trackPlaylistShow({ playlistTitle: title })
  }, [title, trackPlaylistShow])

  useEffect(() => {
    queryClient.invalidateQueries('playlist-videos')
  }, [queryClient])

  return <Playlist hideInDesktop={true} />
}

const widget: CookWidget = {
  kind: ['widget', 'playlist-videos'],
  component: PlaylistVideosWidget,
}

export default widget
